module.exports = __webpack_public_path__ + "img/laterale_sx.109d97fb.png";